import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css'

const handleAutoScroll = (sliders) => {
  sliders.forEach((el) => {
    const numSlides = el.querySelectorAll(".splide__slide").length;
    const speed = parseInt(el.dataset.sliderSpeed) || 1;
    const gap = parseInt(el.dataset.sliderGap) || 20;

    if (numSlides < 2) {
      return;
    }

    const splide = new Splide(el, {
      perPage: 'auto',
      perMove: 1,
      type: 'loop',
      pagination: false,
      arrows: false,
      autoWidth: true,
      gap: gap,
      autoScroll: {
        speed: speed,
        pauseOnHover: true,
        pauseOnFocus: true,
      },
    }).mount({ AutoScroll });
  });
}

export default {
  init: () => {
    const autoScrollSliders = document.querySelectorAll("[data-auto-scroll='true']");

    if (autoScrollSliders.length) {
      handleAutoScroll(autoScrollSliders);
    }
  }
}
